module.exports = __webpack_public_path__ + "media/images/web_suite/vb_suite_icon-26864eac54695c64cd1c748de441001f.png";